import { AlertSettingsCard, NotificationPreferencesCard } from "@khazzin/ui/patterns";
import { useApi } from "../../api";
import { useLocale } from "../../app/shell/locale";
import { useStoreScope } from "../../app/shell/scope";
import { levelOf } from "../../app/shell/sections";

const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

/**
 * Settings → Notifications in the Store Portal (EP12-S16, CR-021): the
 * person's own matrix over the store's defaults, and — for whoever may write
 * the store's Settings — the store's defaults themselves. A tab of
 * {@link SettingsPage} (EP10-S11), which holds the section gate. EP10-S12
 * adds the rest of the portal's per-sub-account notification screen around it.
 *
 * EP12-S14 adds the store's alert settings (DA-12-11): the digest's time and
 * zone, the stuck-order SLA and the low-stock trickle, each with the value in
 * effect and whether it is the organisation's or the store's own, and a
 * preview of the next digest. Read-only at `settings = read`.
 */
export function NotificationSettings() {
	const { t } = useLocale();
	const api = useApi();
	const { store } = useStoreScope();
	if (store === null) {
		return null;
	}
	return (
		<div className="flex flex-col gap-4">
			<NotificationPreferencesCard
				api={api}
				t={t}
				title={t("portal.settings.notifications.mine")}
				subtitle={t("portal.settings.notifications.mineHint")}
				storeId={store.storeId}
				defaultTimezone={timeZone}
			/>
			{levelOf(store, "settings") === "write" && (
				<NotificationPreferencesCard
					api={api}
					t={t}
					title={t("portal.settings.notifications.store")}
					subtitle={t("portal.settings.notifications.storeHint")}
					scopeRef={`store:${store.storeId}`}
					defaultTimezone={timeZone}
				/>
			)}
			<AlertSettingsCard
				t={t}
				title={t("portal.settings.alerts.title")}
				subtitle={t("portal.settings.alerts.hint")}
				queryKey={["alertRules", "store", store.storeId]}
				load={(signal) => api.getPortalAlertRules({ signal })}
				save={(key, value) => api.putPortalAlertRule(key, value)}
				preview={() => api.previewPortalDigest()}
				editable={levelOf(store, "settings") === "write"}
			/>
		</div>
	);
}
